import { render, staticRenderFns } from "./AutocompleteOption.vue?vue&type=template&id=523ce3c1&scoped=true"
import script from "./AutocompleteOption.vue?vue&type=script&lang=js"
export * from "./AutocompleteOption.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteOption.vue?vue&type=style&index=0&id=523ce3c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ce3c1",
  null
  
)

export default component.exports